export const ZERO_DECIMAL_CURRENCIES = [
  "BIF", "CLP", "COP", "DJF", "GNF", "JPY", "KMF", "KRW",
  "MGA", "PYG", "RWF", "UGX", "VND", "VUV",
  "XAF", "XOF", "XPF"
] as const;

export const isZeroDecimalCurrency = (currency: string) =>
  ZERO_DECIMAL_CURRENCIES.includes(currency as any);

